module.exports = __webpack_public_path__ + "static/media/campus2.9f135ad4.jpg";